
import { Component, Prop, Vue } from 'vue-property-decorator'

import BacCustomerWidget from './BacCustomerWidget.vue'

@Component({
  components: {
    BacCustomerWidget
  }
})
export default class BacCustomers extends Vue {
    @Prop({ required: true }) public teamId!: number;

    mounted () {
      this.$store.dispatch('loadTeam', this.teamId)
    }
}

